var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container-small"},[_c('otp-code',{ref:"otpInput",attrs:{"otp-verify":_vm.otpVerify,"otp-valid":_vm.otpValid},on:{"update:otpValid":function($event){_vm.otpValid = $event}}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }